export default "__VITE_ASSET__HFp91G2y__"